import { useState } from "react";
import axios from "axios";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CircularProgress from "@mui/material/CircularProgress";
import { useFormContext } from "react-hook-form";
import { useNotify } from "react-admin";
import Typography from "@mui/material/Typography";
import {
  HiOutlineCloudUpload,
  HiOutlineTrash,
  HiOutlineUpload,
  HiOutlineX,
} from "react-icons/hi";
import { colors, radius } from "../../data/tokens";
export const FileUploadComponent = (props: any) => {
  const notify = useNotify();

  const { getValues, setValue, getFieldState } = useFormContext();
  //   const { save } = useForm();
  const [selectedFile, setSelectedFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadMessage, setUploadMessage] = useState("");
  const [uploadedFile, setUploadedFile] = useState<any>({});
  const handleFileChange = (event: any) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      setUploadMessage("Favor selecionar um arquivo para enviar.");
      return;
    }

    setIsUploading(true);

    try {
      const formData = new FormData();
      formData.append("file", selectedFile);

      // Sem Content-Type manual: com FormData, o axios/navegador define
      // "multipart/form-data" COM boundary — que é o que o FileInterceptor
      // (multer) do backend precisa para achar o campo "file". O
      // "application/octet-stream" que havia aqui ia sem boundary, o multer
      // devolvia file vazio e o backend respondia "No file uploaded": o
      // upload quebrava silenciosamente.
      const response = await axios.post(
        `${process.env.REACT_APP_API_PATH}/users/upload/file`,
        formData
      );

      if (response.status >= 200 && response.status < 300) {
        // O upload.php as vezes imprime um aviso do PHP ANTES do JSON
        // (ex.: "Warning: Undefined variable $rawData ... on line 31"),
        // poluindo a resposta: o response.data chega como texto com o
        // aviso grudado antes do {"path":...,"name":...}. Sem tratar, o
        // physicalCardPicture era gravado como essa string e o .path
        // ficava indefinido -> o perfil caia nas iniciais. Extrai so o
        // trecho JSON e grava como objeto. (A correcao de raiz e no
        // proprio upload.php, na hospedagem.)
        let uploaded: any = response.data;
        if (typeof uploaded === "string") {
          const start = uploaded.indexOf("{");
          const end = uploaded.lastIndexOf("}");
          if (start >= 0 && end > start) {
            try {
              uploaded = JSON.parse(uploaded.slice(start, end + 1));
            } catch (e) {
              // mantem o valor original se nao for possivel parsear
            }
          }
        }
        setUploadMessage("Arquivo enviado com sucesso.");
        setValue("physicalCardPicture", uploaded);
        notify("Enviando arquivo para o servidor, aguarde...", {
          type: "warning",
        });

        if (props.save) {
          setTimeout(() => {
            props.save(getValues());
          }, 3000);
        }
      } else {
        setUploadMessage("Envio do arquivo falhou, consulte o suporte. #1");
      }
    } catch (error: any) {
      console.error("Error uploading file:", error.message);
      setUploadMessage("Envio do arquivo falhou, consulte o suporte. #2");
    } finally {
      setIsUploading(false);
    }
  };
  /**
   * Evaluates if the sendFile field should be shown.
   * It should show if:
   * - we can access props.controller.record.hasPhysicalCard but hasPhysicalCard.path is empty (Eg.: {}) (editing existing record)
   * - there's no props.controller or id (creating new record)
   * @param props any
   * @returns boolean
   */
  function showSendFileField(props: any) {
    const physicalCardPicture = props?.controller?.record?.physicalCardPicture;
    const physicalCardPicturePath = physicalCardPicture?.path;
    const hasPhysicalCardPathEmpty =
      physicalCardPicturePath === undefined ||
      physicalCardPicturePath === null ||
      physicalCardPicturePath === "";
    const isCreatingNewRecord = !props.controller || !props.id;
    // console.log(
    //   "showSendFileField",
    //   (physicalCardPicture && hasPhysicalCardPathEmpty) || isCreatingNewRecord
    // );
    return (
      (physicalCardPicture && hasPhysicalCardPathEmpty) ||
      isCreatingNewRecord ||
      !physicalCardPicture
    );
  }
  return (
    <div>
      {showSendFileField(props) && (
        <>
          {/* Dropzone: rótulo estilizado com o input de arquivo oculto —
              mesma lógica de seleção/envio de antes, só o visual mudou */}
          <Box
            component="label"
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              position: "relative",
              gap: 0.75,
              border: `2px dashed ${colors.border}`,
              borderRadius: `${radius.md}px`,
              padding: "20px 12px",
              cursor: "pointer",
              color: colors.textMuted,
              transition: "border-color 0.2s ease, background-color 0.2s ease",
              "&:hover": {
                borderColor: colors.primaryHover,
                backgroundColor: colors.bgSubtle,
              },
            }}
          >
            {selectedFile && (
              <IconButton
                aria-label="Remover arquivo selecionado"
                size="small"
                onClick={(e) => {
                  // Dentro do <label>: previne abrir o seletor de arquivo
                  e.preventDefault();
                  e.stopPropagation();
                  setSelectedFile(null);
                  setUploadMessage("");
                }}
                sx={{
                  position: "absolute",
                  top: 4,
                  right: 4,
                  color: colors.textMuted,
                }}>
                <HiOutlineX size={16} />
              </IconButton>
            )}
            <HiOutlineCloudUpload size={24} />
            <Typography
              sx={{
                fontSize: 13,
                fontWeight: selectedFile ? 600 : 400,
                color: selectedFile ? colors.primaryDark : colors.textMuted,
                textAlign: "center",
                overflowWrap: "anywhere",
              }}
            >
              {selectedFile
                ? (selectedFile as any).name
                : "Clique para escolher a imagem"}
            </Typography>
            <Typography sx={{ fontSize: 11.5 }}>
              {selectedFile ? "Pronta para enviar" : "PNG ou JPG"}
            </Typography>
            <input
              type="file"
              accept="image/*"
              hidden
              // Zera o valor a cada clique: permite reescolher o MESMO
              // arquivo depois de removê-lo (senão o onChange não dispara)
              onClick={(e: any) => {
                e.target.value = "";
              }}
              onChange={handleFileChange}
            />
          </Box>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            sx={{ marginTop: 1.5, height: 48 }}
            startIcon={
              isUploading ? (
                <CircularProgress size={16} sx={{ color: "white" }} />
              ) : (
                <HiOutlineUpload />
              )
            }
            onClick={handleUpload}
            disabled={isUploading || !selectedFile}>
            {isUploading ? "Enviando..." : "Enviar arquivo"}
          </Button>
        </>
      )}

      {props.controller &&
        props.id &&
        getValues() &&
        getValues().physicalCardPicture &&
        getValues().hasOwnProperty("physicalCardPicture") &&
        typeof getValues().physicalCardPicture !== "undefined" &&
        getValues().physicalCardPicture.hasOwnProperty("path") && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: 1.5,
            }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Box
                component="img"
                src={
                  `${process.env.REACT_APP_UPLOAD_PATH}/` +
                  getValues().physicalCardPicture.path
                }
                alt="Foto do sócio"
                sx={{
                  width: 96,
                  height: 96,
                  objectFit: "cover",
                  borderRadius: `${radius.md}px`,
                  border: `1px solid ${colors.border}`,
                }}
              />
              <Typography variant="body2" sx={{ color: colors.textMuted }}>
                Foto atual do sócio
              </Typography>
            </Box>
            <Button
              variant="outlined"
              color="error"
              startIcon={<HiOutlineTrash />}
              onClick={async () => {
                const auth = localStorage.getItem("auth");
                const authJson = auth ? JSON.parse(auth) : auth;
                await axios.put(
                  `${process.env.REACT_APP_API_PATH}/users/crud/${props.id}`,
                  {
                    physicalCardPicture: {},
                  },
                  {
                    headers: {
                      Authorization: `Bearer ${authJson.access_token}`,
                    },
                  }
                );
                await axios.delete(
                  `${process.env.REACT_APP_API_PATH}/users/upload/file/${
                    getValues().physicalCardPicture.name
                  }`,
                  {
                    headers: {
                      Authorization: `Bearer ${authJson.access_token}`,
                    },
                  }
                );
                window.location.reload();
              }}
              disabled={isUploading}>
              Remover foto
            </Button>
          </Box>
        )}
      {uploadMessage && (
        <Typography
          sx={{ fontSize: 12.5, color: colors.textMuted, marginTop: 1 }}
        >
          {uploadMessage}
        </Typography>
      )}
    </div>
  );
};

export default FileUploadComponent;
